import { Nullable } from "common/types";
import { Record, List } from "immutable";
import { DateStringNumber } from ".";
import { checkDate } from "common/helpers/Date";

export const screenShareFromJSON = (json: Partial<IScreenShareData>): ScreenShareRecord => {
  const data: IScreenShareRecord = { ...(json as any) };

  if (data.created_at) {
    data.created_at = checkDate(data.created_at);
  }

  if (data.updated_at) {
    data.updated_at = checkDate(data.updated_at);
  }

  return new ScreenShareRecord(data);
};

export interface RoomParams {
  roomName: string;
  roomUid: string;
  identity: string;
  host: boolean;
  roomExists: boolean;
  audio_preference: string;
}

export interface IScreenShareData {
  id: number;
  kind: string;
  uuid: string;
  uid: string;
  job_id: number;
  shared: Nullable<boolean>;
  start_time: DateStringNumber;
  started: DateStringNumber;
  ended: Nullable<DateStringNumber>;
  event_id: Nullable<number>;
  estimate_id: number;
  metadata: any;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  redirect_on_end_url: string;

  loading?: boolean;
}

export interface IScreenShareRecord {
  id: number;
  kind: string;
  uuid: string;
  uid: string;
  job_id: number;
  shared: boolean;
  start_time: Date;
  started: Date;
  ended: Date;
  event_id: number;
  estimate_id: number;
  metadata: any;
  created_at: Date;
  updated_at: Date;
  redirect_on_end_url: string;

  loading: boolean;
  errors: Nullable<List<string>>;
}

export const defaultScreenShareProps = {
  id: 0,
  kind: "basic",
  uuid: "",
  uid: "",
  job_id: 0,
  shared: false,
  start_time: new Date(),
  started: new Date(),
  ended: new Date(),
  event_id: 0,
  estimate_id: 0,
  metadata: {},
  created_at: new Date(),
  updated_at: new Date(),
  redirect_on_end_url: "",
  loading: false,
  errors: List<string>(),
};

export class ScreenShareRecord
  extends Record<IScreenShareRecord>(defaultScreenShareProps)
  implements IScreenShareRecord {}
